import React, { useState } from "react";
import { Button } from "../../atoms/button";
import { useDispatch, useSelector } from "react-redux";
import { CustomHeadline } from "../../atoms/custom-headline";
import {
  ENTER_OTP,
  MOBILE_OTP_HEADLINE,
  QUILL_EMPTY_STRING,
  UPDATE_SIGN_IN,
  UPDATE_SINGLE_SIGN_ON,
  VERIFY_SIGN_IN_BUTTON,
  SIGN_IN_SUCCESS,
} from "../../../../../constants";
import { ErrorMessage } from "../../atoms/error-message";
import {
  getErrorStyle,
  triggerLogin,
  genericError,
  triggerSSO,
  triggerUpdateWithOtp,
  inputFieldError,
  retrieveNumbers,
} from "../../util";
import get from "lodash/get";
import "./otp-screen.module.css";
import { ResendOtp } from "../../atoms/resend-otp";
import { AgreementText } from "../../atoms/agreement-text";
import { checkIfSingleSignOn } from "../../sso-utils";
import { SuccessMessage } from "../../atoms/success-message";

export const MobileOtpScreen = ({ mode, isUserLoginPage = false, displayData = "" }) => {
  const { general = {}, login = {} } = useSelector((state) => get(state, ["qt", "config", "pagebuilder-config"], {}));
  const { currentPath = "", currentHostUrl = "" } = useSelector((state) => get(state, ["qt"], {}));
  const { button, enterOtpLabel, enterOtpTitle, resendOtpInLabel, resendOtpLabel, agreementText } = get(
    login,
    ["mobile-otp", "rows", 0, "config"],
    {}
  );
  const { loginSuccess = "" } = get(login, ["pageSetting"], {});
  const { sso = {} } = general;
  const [otpValue, setOtpValue] = useState("");
  const [response, setResponse] = useState(null);
  const [api, setApi] = useState(null);
  const [displaySuccess, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const { signIn = {}, singleSignOn = {} } = useSelector((state) => get(state, ["login"], {}));
  const { inputData = "", countryCode = "", qtAuthCookie = "", updateOtp = false } = get(signIn, ["userData"], {});
  const {
    inputData: ssoInputData = "",
    countryCode: ssoCountryCode = "",
    qtAuthCookie: ssoQtAuthCookie = "",
    updateOtp: ssoUpdateOtp = false,
  } = get(singleSignOn, ["userData"], {});
  const data = !isUserLoginPage ? `${countryCode}${inputData}` : `${ssoCountryCode}${ssoInputData}`;
  const authCookie = !isUserLoginPage ? qtAuthCookie : ssoQtAuthCookie;
  const isUpdateOtp = !isUserLoginPage ? updateOtp : ssoUpdateOtp;

  const triggerOnEdit = () => {
    dispatch({ type: !isUserLoginPage ? UPDATE_SIGN_IN : UPDATE_SINGLE_SIGN_ON, payload: { currentScreen: "signIn" } });
  };

  const triggerHandler = async () => {
    if (isUpdateOtp) {
      const updateOtpProps = { otp: otpValue, email: data, authCookie: authCookie };
      const updateWithOtpResponse = await triggerUpdateWithOtp(updateOtpProps);
      setResponse(updateWithOtpResponse);
      setApi("update-with-otp");
      if (updateWithOtpResponse === 200) {
        global?.localStorage?.removeItem("userEmail");
        setSuccess(true);
      }
    } else {
      const loginProps = { data: data, credential: otpValue, type: "otp" };
      const { responseStatus: otpResponseStatus } = await triggerLogin(loginProps);
      setResponse(otpResponseStatus);
      setApi("login-mobile");
      if (otpResponseStatus === 200) {
        if (isUserLoginPage && checkIfSingleSignOn(sso) && window?.location) {
          const ssoProps = { sso: sso, currentHostUrl: currentHostUrl, currentPath: currentPath };
          triggerSSO(ssoProps);
        }
        global?.localStorage?.removeItem("userEmail");
        setSuccess(true);
      }
    }
  };
  const wrapperStyle = displaySuccess ? `auth--wrapper ${mode} success-wrapper` : `auth--wrapper ${mode}`;
  return (
    <div className={wrapperStyle}>
      <CustomHeadline
        headline={enterOtpTitle && enterOtpTitle !== QUILL_EMPTY_STRING ? enterOtpTitle : MOBILE_OTP_HEADLINE}
        editData={displayData || data}
        onEdit={triggerOnEdit}
        id="mobile-otp-headline"
      />
      <div className={getErrorStyle(response, api, mode)} styleName="input-wrapper">
        <label for="otp">{enterOtpLabel || ENTER_OTP}</label>
        <input
          inputmode="numeric"
          pattern="[0-9]*"
          value={otpValue}
          id="otp"
          onChange={(event) => {
            setResponse(null);
            setApi(null);
            setOtpValue(retrieveNumbers(event.target.value));
          }}
          name="otp"
          required
        />
        {inputFieldError(response, api) ? <ErrorMessage response={response} api={api} mode={mode} /> : <></>}
        <ResendOtp
          resendOtpLabel={resendOtpLabel}
          resendOtpInLabel={resendOtpInLabel}
          setResponse={setResponse}
          setApi={setApi}
          email={isUpdateOtp ? data : ""}
          phoneNumber={isUpdateOtp ? "" : data}
        />
      </div>
      <Button
        text={button || VERIFY_SIGN_IN_BUTTON}
        clickHandler={() => triggerHandler()}
        disable={!otpValue}
        enableEnterClick={true}
      />
      {genericError(response, api) ? <ErrorMessage response={response} api={api} mode={mode} /> : <></>}
      {!isUpdateOtp ? <AgreementText currentScreen="otp" customAgreementText={agreementText} /> : <></>}
      {displaySuccess ? (
        <SuccessMessage message={loginSuccess || SIGN_IN_SUCCESS} mode={mode} isUserLoginPage={isUserLoginPage} />
      ) : (
        <></>
      )}
    </div>
  );
};
